//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passTerrainClassification = 3.0;\n\
";
